export const COST_OF_REPAIR = 7;
export const ALCOHOL_LEVEL = 3;
export const HOW_MUCH_FINED = 5;
export const RECEIVED_BAN_PERIOD = 2;
export const BUSINESS_YEAR = 4;
